module.exports = __webpack_public_path__ + "img/randabstand-EC2-ansicht.f15798dc.jpg";